import { API, authClient } from "../index";

export const getOfferDefaultsConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/offers`);

export const updateOfferDefaultsConfig = (config, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/offers`, config);

export const getOperarioMobileConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/operarios`);

export const updateOperarioMobileConfig = (config, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/operarios`, config);

export const getAIPromptsConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/prompts`);

export const updateAIPromptsConfig = (prompts, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/prompts`, prompts);
